import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";
import utils        from "../../Utils";
import Constants    from "../../Constants";

// import Swiper JS
import Swiper, { Navigation, Autoplay, Pagination, EffectFade } from 'swiper'
// import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';

const components = _.merge(ComponentSet,
    {
        'News'     : () => import('./components/News.vue'),
    });
// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data() {
        return {
            deviceWidth: {
                type: Number,
                default: 0
            }
        };
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
        this.deviceWidth = window.innerWidth;
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function() {
            self.$nextTick(function() {
                // banner initialize
                // banner
                const banner_swiper = new Swiper(".banner_swiper", {
                    // configure Swiper to use modules
                    modules: [Navigation, Autoplay, EffectFade],
                    // Optional parameters
                    loop: true,
                    effect: 'fade',
                    autoplay:true,
                    // Navigation arrows
                    navigation: {
                        nextEl: ".banner-button-next",
                        prevEl: ".banner-button-prev",
                    },
                    on: {
                        slideChange:function(swiper){
                            $('.pagebanner_text .scroll-txt h3').hide();
                            $('.pagebanner_text .scroll-txt h3').eq(swiper.realIndex).show()
                        }
                    }
                });

            });
        });
    },
    methods: {        
        
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        bannersData() {
            let bannerList = _.get(this, 'contentData.bannerList', []) || [];
            return bannerList;
        },
        highlightData() {
            let highlightList = _.get(this, 'contentData.highlightList', []) || [];
            return highlightList;
        },
    }, // end of computed
}).$mount('#app');